import { Navigate, useParams } from 'react-router-dom';

/**
 * Where `/pedidos/:orderId/pagamento` (and `/pagamento/:paymentId`) used to open the "pay now"
 * screen. That screen is gone: boleto is the only method and it is issued when the order closes
 * (ADR-0025). An old link, a bookmark or a back button lands on the order instead, which shows its
 * boleto.
 */
export function OrderPaymentRedirect() {
  const { orderId = '' } = useParams();
  return <Navigate to={`/pedidos/${encodeURIComponent(orderId)}`} replace />;
}
